import { MDBBtn, MDBModalFooter } from "mdb-react-ui-kit";
import React, { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useForm } from "react-hook-form";
import { createACDGroup, getMisc } from "../../../apiclients/streamsapi_bridge";

const AddACDGroup = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [checkAvailbility, setCheckAvailbility] = useState("");
    const navigate = useNavigate();
    const { register, handleSubmit, setError, formState, clearErrors } = useForm({
        defaultValues: {
            name: "",
            extension: "",
        }
    });
    const { errors, isDirty } = formState;
    async function checkAvailability(e) {
        if (e.target.value.trim() == "") {
            return;
        }
        console.log(sessionStorage.getItem("admin_session"));
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            { check_ext: parseInt(e.target.value) }
        );
        console.log(response);
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const tdata = await response.json();
        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        if (tdata.check_ext) {
            setCheckAvailbility(true);
            setError("extension", { message: "Extension is available" });
        } else {
            setCheckAvailbility(false);
            setError("extension", { message: "Extension is not available" });
        }
        console.log(tdata);
    }

    const onsubmit = async (data) => {
        let updates = {};
        if (isDirty) {
            updates = {
                reqid: 32,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                name: data.name,
                extension: parseInt(data.extension),
            };
            console.log(updates);
            let saverep = await createACDGroup(
                updates
            );
            let saverepeMsg = await saverep.json();
            console.log(saverepeMsg);
            if (saverepeMsg.status && saverepeMsg.status == "success") {
                localStorage.setItem("s_message", "Group " + data.name + " created successfully.");
                props.onClose();
                window.location.href = "/acdQueues";
            } else {
                if (saverepeMsg.message?.errors) {
                    saverepeMsg.message.errors.forEach((err) => {
                        setError(err.param_name, {
                            type: "server",
                            message: err.message,
                        });
                        const fieldElement = document.querySelector(
                            `input[name="${err.param_name}"]`
                        );
                        if (fieldElement) {
                            fieldElement.focus();

                        }
                    });
                }
            }

        }
    }
    return (
        <>
            <div>
                <div className="tel-numbers">
                    <strong>{t("ACDQueueName")}</strong>
                </div>
                <div className="form pt-1">
                    <input
                        type="text"
                        className="form-control"
                        {...register("name", { required: "Name is required" })}
                    />
                    {errors.name && (
                        <p className="text-danger">{errors.name.message}</p>
                    )}
                </div>
                <div className="tel-numbers mt-2">
                    <strong>{t("extension")}</strong>
                </div>
                <div className="form pt-1">
                    <input
                        type="text"
                        className="form-control"
                        onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                            }
                        }}
                        {...register("extension", {
                            setValueAs: (value) => Number(value),
                            required: "Extension is required",
                            minLength: {
                                value: 3,
                                message: 'Extension must be at least 3 characters',
                            },
                            maxLength: {
                                value: 5,
                                message: 'Extension must not exceed 5 characters',
                            },
                        })}
                        onChange={(e) => {
                            e.preventDefault();
                            if (e.target.value.length >= 3 && e.target.value.length <= 5) {
                                checkAvailability(e);
                            } else {
                                setCheckAvailbility(false);
                                clearErrors("extension");
                            }
                        }}
                    />
                    {errors.extension && (
                        <>
                            {!checkAvailbility && (
                                <>
                                    <p className="text-danger">
                                        {errors.extension.message}
                                    </p>
                                </>
                            )}

                            {checkAvailbility && (
                                <p style={{ color: "Green" }} className="clr-red">
                                    {errors.extension.message}
                                </p>
                            )}
                        </>
                    )}
                </div>
            </div>

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onsubmit)() }}>
                    {t("add")}</button>
            </div>

            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={(e) => {
                    e.preventDefault();
                    handleSubmit(onsubmit)();
                }}>{t("add")}</MDBBtn>
            </MDBModalFooter> */}

        </>
    )
});

export default AddACDGroup
